import _ from 'lodash';

export const EASING_MAP = {
    easeInSine: 'easeInSine',
    easeInQuad: 'easeInQuad',
    easeInCubic: 'easeInCubic',
    easeInQuart: 'easeInQuart',
    easeInQuint: 'easeInQuint',
    easeInExpo: 'easeInExpo',
    easeInCirc: 'easeInCirc',
    easeInBack: 'easeInBack',
    easeInElastic: 'easeInElastic',
    easeInBounce: 'easeInBounce',
    easeOutSine: 'easeOutSine',
    easeOutQuad: 'easeOutQuad',
    easeOutCubic: 'easeOutCubic',
    easeOutQuart: 'easeOutQuart',
    easeOutQuint: 'easeOutQuint',
    easeOutExpo: 'easeOutExpo',
    easeOutCirc: 'easeOutCirc',
    easeOutBack: 'easeOutBack',
    easeOutElastic: 'easeOutElastic',
    easeOutBounce: 'easeOutBounce',
    easeInOutSine: 'easeInOutSine',
    easeInOutQuad: 'easeInOutQuad',
    easeInOutCubic: 'easeInOutCubic',
    easeInOutQuart: 'easeInOutQuart',
    easeInOutQuint: 'easeInOutQuint',
    easeInOutExpo: 'easeInOutExpo',
    easeInOutCirc: 'easeInOutCirc',
    easeInOutBack: 'easeInOutBack',
    easeInOutElastic: 'easeInOutElastic',
    easeInOutBounce: 'easeInOutBounce',
    easeLinear: 'linear'
};

const EASING_NAMES = _.keys(EASING_MAP);

export const animationOptionsMappings = {
    keys: {
        easing: 'ease',
        opacity: 'to.autoAlpha',
        x: 'to.x',
        y: 'to.y',
        degree: 'to.rotation',
        scaleX: 'to.scaleX',
        scaleY: 'to.scaleY',
        scale: 'to.scale',
        direction: 'to.direction'
    },
    values: {
        duration: {
            convertMsToSecs: true
        },
        delay: {
            convertMsToSecs: true
        },
        repeatDelay: {
            convertMsToSecs: true
        }
    }
};

const animationDataSchemas = {
    fade: {
        default: {
            duration: 0,
            delay: 0,
            to: {
                autoAlpha: 1
            },
            ease: 'easeInSine'
        },
        validations: {
            duration: {
                type: 'integer',
                minValue: 0
            },
            delay: {
                type: 'integer',
                minValue: 0
            },
            opacity: {
                type: 'number',
                range: {
                    minValue: 0,
                    maxValue: 1
                }
            },
            easing: {
                type: 'string',
                enum: EASING_NAMES
            }
        }
    },
    position: {
        default: {
            duration: 0,
            delay: 0,
            ease: 'easeInSine'
        },
        validations: {
            duration: {
                type: 'integer',
                minValue: 0
            },
             delay: {
                type: 'integer',
                minValue: 0
            },
            x: {
                type: ['integer', 'string']
            },
            y: {
                type: ['integer', 'string']
            },
            easing: {
                type: 'string',
                enum: EASING_NAMES
            }
        }
    },
    rotate: {
        default: {
            duration: 0,
            delay: 0,
            to: {
                rotation: 0
            },
            ease: 'easeInSine'
        },
        validations: {
            duration: {
                type: 'integer',
                minValue: 0
            },
             delay: {
                type: 'integer',
                minValue: 0
            },
            degree: {
                type: 'number',
                minValue: 0
            },
            direction: {
                type: 'string',
                enum: ['cw', 'ccw']
            },
            easing: {
                type: 'string',
                enum: EASING_NAMES
            }
        }
    },
    scale: {
        default: {
            duration: 0,
            delay: 0,
            ease: 'easeInSine'
        },
        validations: {
            duration: {
                type: 'integer',
                minValue: 0
            },
             delay: {
                type: 'integer',
                minValue: 0
            },
            scaleX: {
                type: 'number',
                minValue: 0
            },
            scaleY: {
                type: 'number',
                minValue: 0
            },
            scale: {
                type: 'number',
                minValue: 0
            },
            easing: {
                type: 'string',
                enum: EASING_NAMES
            }
        }
    },

    sequence: {
        default: {
            repeat: 0,
            repeatDelay: 0,
            yoyo: false
        },
        validations: {
            repeat: {
                type: 'integer',
                minValue: 0
            },
            repeatDelay: {
                type: 'integer',
                minValue: 0
            },
            yoyo: {
                type: 'boolean'
            },
            delay: {
                type: 'integer',
                minValue: 0
            }
        }
    }
};

export function getSchemaOfAnimation(animationType) {
    return _.get(animationDataSchemas, animationType);
}
